module.exports = __webpack_public_path__ + "img/DIT_logo.e188d1e4.png";